.drawer {
  height: 100%;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.status {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 10px;
  border-radius: 4px;
  background: #f6faff;
  font-size: 14px;
}

.actions {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.button {
  width: 100%;
}

.inputFields {
  display: flex;
  gap: 1rem;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.wmsOrgCodeInput {
  max-width: 110px;
  text-align: center;
}
